// import { FILE_UPLOAD_ACTIONS } from '../actions/fileUpload';
import { FILE_UPLOAD_ACTIONS,CASE_DATA_FILES } from '../type';

const initialState = {
    uploadQueue: [], // Files waiting to be uploaded
    activeUploads: {}, // Currently uploading files { uploadId: { fileName, progress, status, ... } }
    completedUploads: [], // Successfully uploaded files
    failedUploads: [], // Failed uploads with error info
    widgetMinimized: false,
    widgetVisible: false,
    presignedUrlGenerationCount: 0, // Counter for files generating presigned URLs
    caseDataFiles: new Map()
};

const fileUploadReducer = (state = initialState, action) => {
    switch (action.type) {
        case FILE_UPLOAD_ACTIONS.ADD_TO_QUEUE: {
            const newFiles = action.payload;
            const newMap = new Map(state.caseDataFiles);
            newFiles.forEach(file => {
                newMap.set(file.uniqueKey, {metaData:file.metaData});
            });
            return {
                ...state,
                uploadQueue: [...state.uploadQueue, ...newFiles],
                caseDataFiles: newMap,
                widgetVisible: true,
            };
        }

        case CASE_DATA_FILES.REMOVE_FILES: {
            const fileData = action.payload;
            const filesToRemove = Array.isArray(fileData) ? fileData : [{ s3UrlPath: fileData }];
            if(filesToRemove.length <= 0){ return state}
            const newMap = new Map(state.caseDataFiles);
            filesToRemove.forEach(file => {
                newMap.delete(file.s3UrlPath);
            });
            return {
                ...state,
                caseDataFiles: newMap
            };
        }
   
        case CASE_DATA_FILES.UPDATE_FILE: {
            const updatedFile = action.payload;
            const newMap = new Map(state.caseDataFiles);
            const existingFile = newMap.get(updatedFile.s3UrlPath);
            newMap.set(updatedFile.s3UrlPath, {
                ...existingFile,
                ...updatedFile
            });
            
            return {
                ...state,
                caseDataFiles: newMap
            };
        }

        case FILE_UPLOAD_ACTIONS.START_UPLOAD: {
            const { uploadId } = action.payload;
            const fileToUpload = state.uploadQueue.find(f => f.id === uploadId);

            if (!fileToUpload) return state;

            return {
                ...state,
                uploadQueue: state.uploadQueue.filter(f => f.id !== uploadId),
                activeUploads: {
                    ...state.activeUploads,
                    [uploadId]: {
                        ...fileToUpload,
                        status: 'uploading',
                        progress: 0,
                        startTime: Date.now(),
                    },
                },
            };
        }

        case FILE_UPLOAD_ACTIONS.UPDATE_PROGRESS: {
            const { uploadId, progress } = action.payload;

            if (!state.activeUploads[uploadId]) return state;

            return {
                ...state,
                activeUploads: {
                    ...state.activeUploads,
                    [uploadId]: {
                        ...state.activeUploads[uploadId],
                        progress,
                    },
                },
            };
        }

        case FILE_UPLOAD_ACTIONS.UPLOAD_SUCCESS: {
            const { uploadId, result } = action.payload;
            const uploadedFile = state.activeUploads[uploadId];

            if (!uploadedFile) return state;

            const { [uploadId]: _removed, ...remainingActive } = state.activeUploads;

            return {
                ...state,
                activeUploads: remainingActive,
                completedUploads: [
                    ...state.completedUploads,
                    {
                        ...uploadedFile,
                        status: 'completed',
                        progress: 100,
                        result,
                        completedTime: Date.now(),
                    },
                ],
            };
        }

        case FILE_UPLOAD_ACTIONS.UPLOAD_FAILED: {
            const { uploadId, error } = action.payload;
            const failedFile = state.activeUploads[uploadId];

            if (!failedFile) return state;

            const { [uploadId]: _removed, ...remainingActive } = state.activeUploads;

            return {
                ...state,
                activeUploads: remainingActive,
                failedUploads: [
                    ...state.failedUploads,
                    {
                        ...failedFile,
                        status: 'failed',
                        error,
                        failedTime: Date.now(),
                    },
                ],
            };
        }

        case FILE_UPLOAD_ACTIONS.RETRY_UPLOAD: {
            const { uploadId } = action.payload;
            const failedFile = state.failedUploads.find(f => f.id === uploadId);

            if (!failedFile) return state;

            return {
                ...state,
                failedUploads: state.failedUploads.filter(f => f.id !== uploadId),
                uploadQueue: [...state.uploadQueue, { ...failedFile, status: 'pending' }],
            };
        }

        case FILE_UPLOAD_ACTIONS.CANCEL_UPLOAD: {
            const { uploadId } = action.payload;

            // Remove from active uploads
            const { [uploadId]: _removed, ...remainingActive } = state.activeUploads;

            return {
                ...state,
                activeUploads: remainingActive,
                uploadQueue: state.uploadQueue.filter(f => f.id !== uploadId),
            };
        }

        case FILE_UPLOAD_ACTIONS.REMOVE_UPLOAD: {
            const { uploadId } = action.payload;

            return {
                ...state,
                completedUploads: state.completedUploads.filter(f => f.id !== uploadId),
                failedUploads: state.failedUploads.filter(f => f.id !== uploadId),
            };
        }

        case FILE_UPLOAD_ACTIONS.CLEAR_COMPLETED: {
            return {
                ...state,
                completedUploads: [],
            };
        }

        case FILE_UPLOAD_ACTIONS.TOGGLE_WIDGET: {
            const { isMinimized } = action.payload;
            return {
                ...state,
                widgetMinimized: isMinimized !== undefined ? isMinimized : !state.widgetMinimized,
            };
        }

        case FILE_UPLOAD_ACTIONS.PRESIGNED_URL_GENERATION_START: {
            const { count } = action.payload;
            return {
                ...state,
                presignedUrlGenerationCount: state.presignedUrlGenerationCount + count,
            };
        }

        case FILE_UPLOAD_ACTIONS.PRESIGNED_URL_GENERATION_COMPLETE: {
            const { count } = action.payload;
            return {
                ...state,
                presignedUrlGenerationCount: Math.max(0, state.presignedUrlGenerationCount - count),
            };
        }

        default:
            return state;
    }
};

export default fileUploadReducer;
